import { createContext, useContext, useMemo } from 'react';

import { getPrismicClient } from '@/account/content';

import type { Client as PrismicClient } from '@prismicio/client';
import type { FunctionComponent, PropsWithChildren } from 'react';

const PrismicClientContext = createContext<PrismicClient | undefined>(
  undefined
);

export const PrismicClientProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const prismicClient = useMemo(() => getPrismicClient(), []);

  return (
    <PrismicClientContext.Provider value={prismicClient}>
      {children}
    </PrismicClientContext.Provider>
  );
};

export function usePrismicClientContext(): PrismicClient {
  const prismicClient = useContext(PrismicClientContext);
  if (!prismicClient) {
    throw new Error(
      'usePrismicClientContext must be used within a PrismicClientProvider'
    );
  }

  return prismicClient;
}
